export const getImageClassModifier = (isCarousel: boolean, isZoomImage: boolean): string => {
  const imageClassModifier = [];
  imageClassModifier.push(isCarousel ? 'c-lead-image--carousel' : 'c-lead-image--single');
  imageClassModifier.push(isZoomImage ? 'c-lead-image--pan-zoom' : '');
  return imageClassModifier.join(' ');
};
